import React, { Component } from 'react'
import { ThunkDispatch } from 'redux-thunk'
import CSS from 'csstype';
import { RootState } from '../../store';
import { connect } from 'react-redux'
import {RouteComponentProps, withRouter} from "react-router-dom";

// Components.
import ProductOverlay from '../shared/ProductOverlay';
import ProductListItem from '../shared/ProductListItem';
import FilterComponent from './FilterComponent';
import StickyHeader from './StickyHeader';
import InfinityList from './InfinityList';
import ProductGridViewToggle from './ProductGridViewToggle';
import {
    ProductGridViewUiMode,
    plClassName,
    readProductGridView,
    wrapperClassName,
    writeProductGridView,
    isEditorialHalfItem,
} from '../../utils/productGridView';

// Store.
import { IOrderState } from '../../store/order/orderStore';
import { IFilterState } from '../../store/session/reducers';
import { getOrder, applyChanges } from '../../store/order/actions';
import { IProductState } from '../../store/products/reducers';
import ProductApi from '../../store/products/ProductApi';
import OrderApi from '../../store/order/OrderApi';
import { IUserSate } from '../../store/user/reducers';
import { IWishlistState } from '../../store/wishlist/reducers';
import { toggleWishlistItem } from '../../store/wishlist/actions';
import { wishlistItemKey } from '../../store/wishlist/wishlistKey';

// Utils.
import { ReactComponent as FilterIcon } from '../../images/svg/filter_icon_black.svg';
import { FilterHelper } from '../../utils/FilterHelper';
import { triggerWishlistFlyAnimation } from '../../utils/wishlistFlyAnimation';
import {
    parseShopOrderCollectionFromPath,
    readShopListScroll,
    saveShopListScroll,
    clearShopListScroll,
    ShopListScrollState,
} from '../../utils/lastShopReturnContext';
import {
    readProductListScrollTop,
    setProductListScrollTop,
    hasProductListScrollContainer,
    getProductListScrollTarget,
} from '../../utils/shopListScroll';
import {
    B2B_CLOSE_PRODUCT_OVERLAY_EVENT,
    closeProductOverlayHistory,
    createProductOverlayPopstateListener,
    pushProductOverlayHistory,
    replaceProductOverlayHistory,
} from '../../utils/productOverlayHistory';
import { uniq, clone, orderBy, sortBy } from 'lodash';
import { productListCategorySort } from '../../constants/productSort';

// import { TransitionGroup, CSSTransition } from 'react-transition-group';
// import InfiniteScroll from 'react-infinite-scroller';

// Models.
import Order from '../../models/Order';
// import Style, { createStyle } from '../../models/Style'
import Style, { createStyle, isColorBlocked } from 'molo-shared/lib/models/Style';
import { filterPurchasableStyles } from '../../utils/styleAvailability';
import {
    partitionSeasonCodesByOrderMatch,
    seasonAllowedForOrder,
} from '../../utils/seasonOrderTypeMatch';
import {
    getOtherOpenOrderDisplay,
    OtherOpenOrderRef,
} from '../../utils/openOrderBasketHints';
import { basketLine } from '../../models/Basket';
import { MoloItem } from '../../models/MoloItem';
import { StyleBean } from '../../models/Beans';

// Third party.
import { TweenLite } from "gsap";
import { Console } from 'console';
// import ClipLoader from 'react-spinners/ClipLoader';

interface IHeader {
    description: string
}

interface IElements {
    type: 'style' | 'iheader'
    style?: Style | undefined,
    header?: IHeader
}

interface ICategory { [id: string]: Style[]; }

export type AgeSegmentQuickFilter = 'all' | 'baby' | 'junior' | 'youth';

interface State {
    order: Order | null,
    productOverlayComponent: JSX.Element | null,
    showModal: boolean,
    filteredStyles: Style[],
    productSortedByCategory: ICategory,
    productSortedByCategoryAsMap: Map<string, Style[]>,
    changes: basketLine,
    showFilter: boolean,
    selectedDeliveryWindow: string | undefined
    selectedSustainability: string[] | undefined
    selectedProduct?: StyleBean
    stickies: string[]
    listIndex: number,
    products: Style[],
    chunked: Style[][]
    infiniteLoaderCurrentIndex: number,
    currentCategory: string,
    elements: IElements[],
    hasMore: boolean,
    showInSeasonOnly: boolean,
    ageSegmentQuickFilter: AgeSegmentQuickFilter,
    /** Bumped when quick filters or product/collection context changes; drives Filter facet refresh. */
    facetRevision: number,
    gridViewMode: ProductGridViewUiMode,
    isScrollRestoring: boolean,
    /** null = no season restriction (no open order, final order, or fetch failed). */
    allowedSeasonCodes: string[] | null,
}
  
interface OwnProps {
    products: Style[],
    lineDiscount?: number,
    ignoreFilter?: boolean
    /** When true with ignoreFilter false: still apply Redux filter to grid but hide FilterComponent + toggler (e.g. wishlist). */
    hideFilterChrome?: boolean
    /** Shown in the same fixed row as the filter toggler (e.g. wishlist “clear all”). */
    renderExtraToolbarRow?: React.ReactNode
    /**
     * When `simple` is true and this is set, use the same floating chrome as the shop grid:
     * top title bar, in-list sticky category heading, and optional `renderExtraToolbarRow`.
     */
    simpleFloatingCategoryTitle?: string
    showGoBack?: boolean
    lazyLoadMoloMaster?: boolean
    orderType?: string
    useProductOrderType?: boolean,
    useInfiniteScroll?: boolean,
    simple?: boolean
    match: {params: {orderType: string, collection: string}},
    hidePrice?: boolean
    checkOrderType?: boolean
    /** Wishlist: Model.AllOrderTypesForMasterColor via GetAllItemOrderTypes. */
    useAllOrderTypesForMasterColor?: boolean
    /** Wishlist: valid order types per master/color (from GetWishList DTO). */
    validOrderTypesByKey?: Record<string, string[]>
    /** Collection master grids: show Baby/Junior/Youth quick filter next to filter toggler. */
    showAgeSegmentQuickFilter?: boolean
    /** Simple list (e.g. Favorites): group products by seasonCode with StickyHeader dividers. */
    groupSimpleListBySeason?: boolean
    /** Favorites: dim and deprioritize seasons not on the active open order type. */
    highlightIncompatibleSeasons?: boolean
    /** Favorites: master|color on other open orders (excludes active). */
    otherOpenOrdersByKey?: Record<string, OtherOpenOrderRef[]>
}
  
interface DispatchProps {
    getOrder: (appOrderId: number) => void
    applyChanges: (orderId: number, changes: basketLine) => void
    toggleWishlistItem: (
        masterId: string,
        colorCode: string,
        isCurrentlyOnList: boolean
    ) => Promise<void>
}
  
interface StateProps {
    orderState: IOrderState
    filterState: IFilterState
    productState: IProductState
    userState: IUserSate
    wishlist: IWishlistState
}
  
type Props = StateProps & OwnProps & DispatchProps & RouteComponentProps;

export const groupBy = (key: any) => (array: any[]) =>
array.reduce((objectsByKeyValue: { [x: string]: any; }, obj: { [x: string]: any; }) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
}, {});

export class ProductList extends Component<Props, State> {
    private static orderTypeSeasonsCache = new Map<string, string[]>();
    private orderTypeSeasonsRequestId = 0;

    constructor(props: Props) {
        super(props);
    
        this.box = null;
        this.t = null;
    }

    box: HTMLDivElement | null;
    t: ReturnType<typeof TweenLite.from> | null;
    private pendingScrollRestore: (ShopListScrollState & { pathname: string }) | null = null;
    private appliedScrollRestore: (ShopListScrollState & { pathname: string }) | null = null;
    private deferListResetForScrollRestore = false;
    private scrollRestoreApplyAttempts = 0;
    private scrollRestoreHideFallbackTimer: number | null = null;
    private lastKnownScrollTop = 0;
    private scrollTrackingTarget: Element | Window | null = null;
    private scrollPersistTimer: number | null = null;
    private overlayHistoryPushed = false;
    private removeOverlayPopstateListener: (() => void) | null = null;
    private onCloseProductOverlayEvent = () => {
        if (this.state.showModal) {
            this.hide();
        }
    };
    private static readonly MAX_SCROLL_RESTORE_APPLY_ATTEMPTS = 10;
    private static readonly SCROLL_RESTORE_REAPPLY_THRESHOLD_PX = 40;

    private clearScrollRestoreHideFallback = () => {
        if (this.scrollRestoreHideFallbackTimer !== null) {
            window.clearTimeout(this.scrollRestoreHideFallbackTimer);
            this.scrollRestoreHideFallbackTimer = null;
        }
    };

    private scheduleScrollPersist = () => {
        if (this.scrollPersistTimer !== null) {
            return;
        }

        this.scrollPersistTimer = window.setTimeout(() => {
            this.scrollPersistTimer = null;
            const pathname = this.getShopListPathname();
            if (!pathname) {
                return;
            }

            const elementCount = this.state.elements.length;
            if (elementCount <= 0) {
                return;
            }

            saveShopListScroll(pathname, this.lastKnownScrollTop, elementCount);
        }, 250);
    };

    private clearScrollPersistTimer = () => {
        if (this.scrollPersistTimer !== null) {
            window.clearTimeout(this.scrollPersistTimer);
            this.scrollPersistTimer = null;
        }
    };

    private handleScrollPositionTrack = () => {
        this.lastKnownScrollTop = readProductListScrollTop();
        this.scheduleScrollPersist();
    };

    private unbindScrollPositionTracking = () => {
        if (!this.scrollTrackingTarget) {
            return;
        }

        if (this.scrollTrackingTarget === window) {
            window.removeEventListener('scroll', this.handleScrollPositionTrack);
        } else {
            (this.scrollTrackingTarget as HTMLElement).removeEventListener(
                'scroll',
                this.handleScrollPositionTrack
            );
        }

        this.scrollTrackingTarget = null;
    };

    private bindScrollPositionTracking = () => {
        if (!this.props.useInfiniteScroll) {
            return;
        }

        const target = getProductListScrollTarget();
        if (target === this.scrollTrackingTarget) {
            return;
        }

        this.unbindScrollPositionTracking();
        this.scrollTrackingTarget = target;

        if (target === window) {
            window.addEventListener('scroll', this.handleScrollPositionTrack, { passive: true });
        } else {
            (target as HTMLElement).addEventListener('scroll', this.handleScrollPositionTrack, {
                passive: true,
            });
        }

        this.lastKnownScrollTop = readProductListScrollTop();
    };

    private clearPendingScrollRestore = () => {
        const pathname = this.getShopListPathname();
        this.pendingScrollRestore = null;
        if (pathname) {
            clearShopListScroll(pathname);
        }
    };

    private clearAllScrollRestoreState = () => {
        this.deferListResetForScrollRestore = false;
        this.appliedScrollRestore = null;
        this.clearPendingScrollRestore();
        this.clearScrollRestoreHideFallback();
        if (this.state.isScrollRestoring) {
            this.setState({ isScrollRestoring: false });
        }
    };

    private finishScrollRestore = (scrollTop: number, elementCount: number, pathname: string) => {
        setProductListScrollTop(scrollTop);
        this.deferListResetForScrollRestore = false;
        this.appliedScrollRestore = { pathname, scrollTop, elementCount };
        this.clearScrollRestoreHideFallback();
        if (this.state.isScrollRestoring) {
            this.setState({ isScrollRestoring: false });
        }
    };

    private applyPendingScrollRestore = (
        scrollTop: number,
        elementCount: number,
        pathname: string
    ) => {
        if (!hasProductListScrollContainer()) {
            if (this.scrollRestoreApplyAttempts < ProductList.MAX_SCROLL_RESTORE_APPLY_ATTEMPTS) {
                this.scrollRestoreApplyAttempts += 1;
                requestAnimationFrame(() =>
                    this.applyPendingScrollRestore(scrollTop, elementCount, pathname)
                );
            }
            return;
        }

        this.scrollRestoreApplyAttempts = 0;
        this.finishScrollRestore(scrollTop, elementCount, pathname);
    };

    private reapplyScrollIfNeeded = () => {
        const applied = this.appliedScrollRestore;
        if (!applied) {
            return;
        }

        const pathname = this.getShopListPathname();
        if (!pathname || pathname !== applied.pathname) {
            this.appliedScrollRestore = null;
            return;
        }

        if (this.state.elements.length < applied.elementCount) {
            return;
        }

        const currentScroll = readProductListScrollTop();
        if (
            currentScroll <
            applied.scrollTop - ProductList.SCROLL_RESTORE_REAPPLY_THRESHOLD_PX
        ) {
            setProductListScrollTop(applied.scrollTop);
            return;
        }

        this.appliedScrollRestore = null;
    };

    private restoreScrollIfNeeded = () => {
        const pending = this.pendingScrollRestore;
        if (!pending) {
            return;
        }

        const pathname = this.getShopListPathname();
        if (!pathname || pathname !== pending.pathname) {
            this.pendingScrollRestore = null;
            return;
        }

        if (this.state.elements.length < pending.elementCount && this.state.hasMore) {
            this.loadItems();
            return;
        }

        const scrollTop = pending.scrollTop;
        const elementCount = pending.elementCount;
        this.pendingScrollRestore = null;
        clearShopListScroll(pathname);
        this.scrollRestoreApplyAttempts = 0;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.applyPendingScrollRestore(scrollTop, elementCount, pathname);
            });
        });
    };

    private initializeFilterMapWithoutListReset = (
        productsOrCollectionChanged: boolean,
        bumpFacet: boolean,
        prevState: State
    ) => {
        if (!this.props.filterState.filter) {
            return;
        }

        const ageSegmentEffective: AgeSegmentQuickFilter = productsOrCollectionChanged
            ? 'all'
            : this.state.ageSegmentQuickFilter;

        const products = this.buildQuickFilteredProducts(
            this.props.products,
            this.state.showInSeasonOnly,
            ageSegmentEffective
        );

        const filteredStyles = FilterHelper.resultByFilter(
            this.props.filterState.filter,
            products
        );
        const productSortedByCategoryAsMap = this.getProductCategoriesAsMap(filteredStyles);
        const currentCategory = productSortedByCategoryAsMap.keys().next().value;

        this.setState(
            {
                filteredStyles,
                currentCategory,
                productSortedByCategoryAsMap,
                ...(bumpFacet ? { facetRevision: prevState.facetRevision + 1 } : {}),
            },
            () => {
                if (this.state.elements.length === 0) {
                    this.loadItems();
                } else {
                    this.restoreScrollIfNeeded();
                }
            }
        );
    };

    private getShopListPathname = (): string | null => {
        const pathname = this.props.location && this.props.location.pathname;
        if (!pathname || pathname.startsWith('/shop/wishlist/')) {
            return null;
        }
        return parseShopOrderCollectionFromPath(pathname) ? pathname : null;
    };

    /** Safe when route has no `collection` (e.g. `/shop/wishlist/:listname`, `/search/:query`). */
    matchCollection = (props: Props = this.props): string => {
        const p = props.match && props.match.params;
        if (!p || p.collection === undefined || p.collection === null) {
            return '';
        }
        return String(p.collection);
    };

    /**
     * In-season and age quick filters only (before Redux FilterHelper).
     * `ageSegment` allows using `'all'` when collection/products changed before state reset commits.
     */
    private buildQuickFilteredProducts(
        source: Style[],
        showInSeasonOnly: boolean,
        ageSegment: AgeSegmentQuickFilter
    ): Style[] {
        let products = [...source];
        const withOutNOS = products.filter((style) => style.seasonCode !== 'NOS');
        const seasons = uniq(withOutNOS.map((style) => style.seasonCode));
        const years = uniq(seasons.map((seasonCode) => seasonCode.substring(1))).sort().reverse();

        const latestYear = years[0];
        let inSeason = '';

        if (latestYear !== undefined) {
            if (seasons.indexOf(`S${latestYear}`) !== -1) {
                inSeason = `S${latestYear}`;
            }

            if (seasons.indexOf(`W${latestYear}`) !== -1) {
                inSeason = `W${latestYear}`;
            }
        }

        if (showInSeasonOnly) {
            products = products.filter((product) => product.seasonCode === inSeason);
        }

        if (ageSegment !== 'all') {
            const k = ageSegment;
            products = products.filter((p) => p[k] === true);
        }

        products = products.filter((p) => !isColorBlocked(p));
        products = filterPurchasableStyles(products);

        return products;
    }

    getQuickFilteredProducts = (): Style[] =>
        this.buildQuickFilteredProducts(
            this.props.products,
            this.state.showInSeasonOnly,
            this.state.ageSegmentQuickFilter
        );

    private productSortedByCategory: ICategory = {};
    private initialChanges: basketLine = {};
    private tempProductListStyle: CSS.Properties = {
        position: 'relative',
        rowGap: '30px',
        cursor: 'pointer',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gridColumnGap: '30px',
        listStyle: 'none',
        margin: 0,
        padding: 0,
    }

    state: State = {
        order: null,
        productOverlayComponent: null,
        showModal: false,
        filteredStyles: [],
        productSortedByCategory: this.productSortedByCategory,
        changes: this.initialChanges,
        showFilter: false,
        selectedDeliveryWindow: undefined,
        selectedSustainability: [],
        stickies: [],
        listIndex: 0,
        products: [],
        infiniteLoaderCurrentIndex: 0,
        chunked: [[]],
        currentCategory: '',
        elements: [],
        hasMore: true,
        showInSeasonOnly: false,
        productSortedByCategoryAsMap: new Map(),
        ageSegmentQuickFilter: 'all',
        facetRevision: 0,
        gridViewMode: readProductGridView(),
        isScrollRestoring: false,
        allowedSeasonCodes: null,
    }

    shouldApplySeasonOrderHighlight = (): boolean => {
        if (!this.props.highlightIncompatibleSeasons) {
            return false;
        }
        const order = this.props.orderState.order;
        if (!order || !order.orderheader) {
            return false;
        }
        if (order.orderheader.orderIsFinal) {
            return false;
        }
        return true;
    };

    getActiveOrderTypeForSeasonHighlight = (): string | null => {
        if (!this.shouldApplySeasonOrderHighlight()) {
            return null;
        }
        const orderType = this.props.orderState.order!.orderheader.orderType;
        if (!orderType || String(orderType).trim() === '') {
            return null;
        }
        return String(orderType).trim();
    };

    syncOrderTypeSeasons = () => {
        const orderType = this.getActiveOrderTypeForSeasonHighlight();
        if (!orderType) {
            if (this.state.allowedSeasonCodes !== null) {
                this.setState({ allowedSeasonCodes: null });
            }
            return;
        }

        const cached = ProductList.orderTypeSeasonsCache.get(orderType);
        if (cached) {
            if (this.state.allowedSeasonCodes !== cached) {
                this.setState({ allowedSeasonCodes: cached });
            }
            return;
        }

        const requestId = ++this.orderTypeSeasonsRequestId;
        OrderApi.getOrderTypeSeasons(orderType)
            .then((response) => {
                if (requestId !== this.orderTypeSeasonsRequestId) {
                    return;
                }
                const codes = response.data || [];
                ProductList.orderTypeSeasonsCache.set(orderType, codes);
                this.setState({ allowedSeasonCodes: codes });
            })
            .catch((err) => {
                if (requestId !== this.orderTypeSeasonsRequestId) {
                    return;
                }
                console.warn('[b2b] GetOrderTypeSeasons failed', err);
                this.setState({ allowedSeasonCodes: null });
            });
    };

    getSeasonHighlightContext = (): { active: boolean; allowed: string[] | null } => {
        const active = this.shouldApplySeasonOrderHighlight();
        if (!active) {
            return { active: false, allowed: null };
        }
        return { active: true, allowed: this.state.allowedSeasonCodes };
    };

    componentDidMount() {
        this.removeOverlayPopstateListener = createProductOverlayPopstateListener(
            () => this.state.showModal,
            () => this.hide(true)
        );

        window.addEventListener(B2B_CLOSE_PRODUCT_OVERLAY_EVENT, this.onCloseProductOverlayEvent);

        const pathname = this.getShopListPathname();
        if (pathname && this.props.useInfiniteScroll) {
            const saved = readShopListScroll(pathname);
            if (saved) {
                this.pendingScrollRestore = { pathname, ...saved };
                this.deferListResetForScrollRestore = true;
                this.setState({ isScrollRestoring: true });
                this.clearScrollRestoreHideFallback();
                this.scrollRestoreHideFallbackTimer = window.setTimeout(() => {
                    if (this.state.isScrollRestoring) {
                        this.setState({ isScrollRestoring: false });
                    }
                    this.scrollRestoreHideFallbackTimer = null;
                }, 2000);
            }
        }

        this.bindScrollPositionTracking();
        requestAnimationFrame(() => this.bindScrollPositionTracking());
        this.syncOrderTypeSeasons();
    }

    componentWillUnmount() {
        this.clearScrollPersistTimer();
        this.unbindScrollPositionTracking();
        this.clearScrollRestoreHideFallback();
        if (this.removeOverlayPopstateListener) {
            this.removeOverlayPopstateListener();
        }
        this.removeOverlayPopstateListener = null;
        window.removeEventListener(B2B_CLOSE_PRODUCT_OVERLAY_EVENT, this.onCloseProductOverlayEvent);
        this.overlayHistoryPushed = false;

        if (!this.props.useInfiniteScroll) {
            return;
        }

        const pathname = this.getShopListPathname();
        if (!pathname) {
            return;
        }

        const elementCount = this.state.elements.length;
        if (elementCount <= 0) {
            return;
        }

        const scrollTop = Math.max(this.lastKnownScrollTop, readProductListScrollTop());
        saveShopListScroll(pathname, scrollTop, elementCount);
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.useInfiniteScroll) {
            this.bindScrollPositionTracking();
        }

        if (
            prevState.elements.length !== this.state.elements.length &&
            this.pendingScrollRestore
        ) {
            requestAnimationFrame(() => this.bindScrollPositionTracking());
        }
        if (
            prevProps.orderState.remoteOrderSyncToken !== this.props.orderState.remoteOrderSyncToken &&
            Object.keys(this.state.changes).length > 0
        ) {
            this.setState({ changes: {} });
        }

        if (this.props.highlightIncompatibleSeasons) {
            const prevOrder = prevProps.orderState.order;
            const nextOrder = this.props.orderState.order;
            const prevType =
                prevOrder && prevOrder.orderheader ? prevOrder.orderheader.orderType : null;
            const nextType =
                nextOrder && nextOrder.orderheader ? nextOrder.orderheader.orderType : null;
            const prevFinal =
                prevOrder && prevOrder.orderheader ? prevOrder.orderheader.orderIsFinal : true;
            const nextFinal =
                nextOrder && nextOrder.orderheader ? nextOrder.orderheader.orderIsFinal : true;
            if (
                prevType !== nextType ||
                prevFinal !== nextFinal ||
                prevOrder !== nextOrder ||
                prevProps.highlightIncompatibleSeasons !== this.props.highlightIncompatibleSeasons
            ) {
                this.syncOrderTypeSeasons();
            }
        }

        if (this.props.simple && this.props.ignoreFilter) {
            if (this.props.products !== prevProps.products) {
                const products = filterPurchasableStyles(
                    this.props.products.filter((p) => !isColorBlocked(p))
                );
                const productSortedByCategory = this.getProductCategories(products);
                this.setState({ filteredStyles: { ...products }, productSortedByCategory });
            }
            return;
        }

        let filterHasChanged = prevProps.filterState.filter !== this.props.filterState.filter;
        const collection = this.matchCollection();
        const prevCollection = this.matchCollection(prevProps);
        const productsOrCollectionChanged =
            prevProps.products !== this.props.products || prevCollection !== collection;

        if (productsOrCollectionChanged) {
            filterHasChanged = true;
        }

        if (prevState.showInSeasonOnly !== this.state.showInSeasonOnly) {
            filterHasChanged = true;
        }

        if (prevState.ageSegmentQuickFilter !== this.state.ageSegmentQuickFilter) {
            filterHasChanged = true;
        }

        const userChangedQuickFilters =
            prevState.showInSeasonOnly !== this.state.showInSeasonOnly ||
            prevState.ageSegmentQuickFilter !== this.state.ageSegmentQuickFilter;

        if (userChangedQuickFilters && this.pendingScrollRestore) {
            this.clearAllScrollRestoreState();
        }

        const bumpFacet =
            prevProps.products !== this.props.products ||
            prevCollection !== collection ||
            prevState.showInSeasonOnly !== this.state.showInSeasonOnly ||
            prevState.ageSegmentQuickFilter !== this.state.ageSegmentQuickFilter;

        if (filterHasChanged && this.props.filterState.filter) {
            const shouldDeferListReset =
                this.deferListResetForScrollRestore &&
                !productsOrCollectionChanged &&
                !userChangedQuickFilters;

            if (shouldDeferListReset) {
                if (this.state.productSortedByCategoryAsMap.size === 0) {
                    this.initializeFilterMapWithoutListReset(
                        productsOrCollectionChanged,
                        bumpFacet,
                        prevState
                    );
                }
            } else {
                const ageSegmentEffective: AgeSegmentQuickFilter = productsOrCollectionChanged
                    ? 'all'
                    : this.state.ageSegmentQuickFilter;

                const products = this.buildQuickFilteredProducts(
                    this.props.products,
                    this.state.showInSeasonOnly,
                    ageSegmentEffective
                );

                const filteredStyles = FilterHelper.resultByFilter(
                    this.props.filterState.filter,
                    products
                );

                const productSortedByCategoryAsMap =
                    this.getProductCategoriesAsMap(filteredStyles);

                const iterator1 = productSortedByCategoryAsMap.keys();

                const currentCategory = iterator1.next().value;

                const shouldResetAgeSegment =
                    productsOrCollectionChanged && this.state.ageSegmentQuickFilter !== 'all';

                this.setState(
                    {
                        filteredStyles,
                        currentCategory,
                        productSortedByCategoryAsMap,
                        ...(shouldResetAgeSegment
                            ? { ageSegmentQuickFilter: 'all' as AgeSegmentQuickFilter }
                            : {}),
                        ...(bumpFacet ? { facetRevision: prevState.facetRevision + 1 } : {}),
                    },
                    () => {
                        this.updateItems();
                    }
                );
            }
        }

        if (this.props.ignoreFilter && this.props.products !== prevProps.products) {
            const products = filterPurchasableStyles(
                this.props.products.filter((p) => !isColorBlocked(p))
            );
            const productSortedByCategory = this.getProductCategories(products);
            this.setState({ filteredStyles: { ...products }, productSortedByCategory });
        }
    }

    normalizeSeasonCode = (style: Style): string => {
        const raw = style.seasonCode;
        if (raw === undefined || raw === null || String(raw).trim() === '') {
            return 'Unknown';
        }
        return String(raw).trim();
    };

    getOrderedSeasonCodes = (seasonCodes: string[]): string[] => {
        const keys = uniq(
            seasonCodes.filter((code) => code !== undefined && code !== null && String(code).trim() !== '')
        );
        if (!keys.length) {
            return [];
        }

        const keySet: Record<string, boolean> = {};
        keys.forEach((code) => {
            keySet[code] = true;
        });

        const sortKeys: string[] = [];
        const fashionKeys = keys.filter((code) => code !== 'NOS');
        const years = uniq(
            fashionKeys
                .map((seasonCode) => seasonCode.substring(1))
                .filter((year) => year.length > 0)
        );

        for (const year of years.sort().reverse()) {
            const wKey = 'W' + year;
            const sKey = 'S' + year;
            if (keySet[wKey]) {
                sortKeys.push(wKey);
            }
            if (keySet[sKey]) {
                sortKeys.push(sKey);
            }
        }

        const remaining = keys
            .filter((code) => code !== 'NOS' && sortKeys.indexOf(code) === -1)
            .sort();
        sortKeys.push(...remaining);

        if (keySet['NOS']) {
            sortKeys.push('NOS');
        }

        return sortKeys;
    };

    groupStylesBySeasonCode = (styles: Style[]): Array<{ seasonCode: string; styles: Style[] }> => {
        const filtered = filterPurchasableStyles(styles).filter((product) => !isColorBlocked(product));
        const buckets: Record<string, Style[]> = {};

        for (const style of filtered) {
            const key = this.normalizeSeasonCode(style);
            if (!buckets[key]) {
                buckets[key] = [];
            }
            buckets[key].push(style);
        }

        const orderedSeasonCodes = this.getOrderedSeasonCodes(Object.keys(buckets));
        const { active, allowed } = this.getSeasonHighlightContext();
        const seasonOrder =
            active && allowed !== null
                ? partitionSeasonCodesByOrderMatch(orderedSeasonCodes, allowed)
                : orderedSeasonCodes;

        return seasonOrder
            .map((seasonCode) => ({
                seasonCode,
                styles: orderBy(buckets[seasonCode] || [], ['masterId'], ['asc']),
            }))
            .filter((group) => group.styles.length > 0);
    };

    sortBySeasonMaster = (categories: Style[]) => {
        const groups = this.groupStylesBySeasonCode(categories);
        const newSort: Style[] = [];
        for (const group of groups) {
            for (const style of group.styles) {
                newSort.push(style);
            }
        }
        return newSort;
    }

    getSimpleListProducts = (): Style[] => {
        return filterPurchasableStyles(this.props.products || []).filter(
            (product: Style) => !isColorBlocked(product)
        );
    };

    renderSimpleProductRow = (product: Style, index: number) => {
        const { active, allowed } = this.getSeasonHighlightContext();
        const seasonMismatch =
            active &&
            allowed !== null &&
            !seasonAllowedForOrder(this.normalizeSeasonCode(product), allowed);
        const rowClassName =
            wrapperClassName(this.state.gridViewMode, index) +
            (seasonMismatch ? ' pl-item--order-season-mismatch' : '');

        const inBasket = this.isInBasket(product);
        let otherOpenOrderLabel: string | undefined;
        let otherOpenOrderTitle: string | undefined;
        if (!inBasket && this.props.otherOpenOrdersByKey) {
            const key = wishlistItemKey(product.masterId, product.colorCode);
            const others = this.props.otherOpenOrdersByKey[key];
            const display = getOtherOpenOrderDisplay(others);
            if (display) {
                otherOpenOrderLabel = display.label;
                otherOpenOrderTitle = display.title;
            }
        }

        return (
        <li
            key={product.masterId + '-' + product.colorCode}
            onClick={() => this.handleOnProductClick(product)}
            className={rowClassName}
        >
            <ProductListItem
                product={StyleBean.build(product, 'style')}
                discount={this.props.lineDiscount}
                inBasket={inBasket}
                otherOpenOrderLabel={otherOpenOrderLabel}
                otherOpenOrderTitle={otherOpenOrderTitle}
                lazyLoadMoloMaster={this.props.lazyLoadMoloMaster}
                quantityLabel={'Available'}
                hidePrice={this.props.hidePrice}
                wishlistOn={this.isOnWishlist(product)}
                wishlistLoading={
                    this.props.wishlist.loading ||
                    this.props.wishlist.mutatingKey ===
                        wishlistItemKey(product.masterId, product.colorCode)
                }
                onWishlistClick={(e) => this.handleWishlistToggle(e, product)}
                imageProfile={
                    isEditorialHalfItem(this.state.gridViewMode, index) ? 'large' : 'thumb'
                }
            />
        </li>
        );
    };

    renderSimpleProductListBody = () => {
        const products = this.getSimpleListProducts();

        if (this.props.groupSimpleListBySeason) {
            const groups = this.groupStylesBySeasonCode(products);
            const showSeasonHeaders = groups.length > 1;

            if (!groups.length) {
                return <ul className={plClassName(this.state.gridViewMode)} />;
            }

            return (
                <React.Fragment>
                    {groups.map(({ seasonCode, styles }) => (
                        <React.Fragment key={seasonCode}>
                            {showSeasonHeaders && (
                                <StickyHeader
                                    title={seasonCode}
                                    onSticky={this.onSticky}
                                    onUnSticky={this.onUnSticky}
                                />
                            )}
                            <ul className={plClassName(this.state.gridViewMode)}>
                                {styles.map((product, index) =>
                                    this.renderSimpleProductRow(product, index)
                                )}
                            </ul>
                        </React.Fragment>
                    ))}
                </React.Fragment>
            );
        }

        return (
            <ul className={plClassName(this.state.gridViewMode)}>
                {products.map((product, index) => this.renderSimpleProductRow(product, index))}
            </ul>
        );
    };

    getProductCategoriesAsMap(styles: Style[]): Map<string, Style[]> {
        let categories: ICategory = {};
        let collectionName = this.matchCollection();

        if (!styles.length) return new Map();

        for (const style of styles) {
            const cat = style.productCategory;
            if (!cat || typeof cat !== 'string' || cat.trim() === '') {
                continue;
            }
            if (!categories[cat]) {
                categories[cat] = [];
            }
            categories[cat].push(style);
        }

        for (const i in categories) {
            categories[i] = orderBy(categories[i], ['masterId'],['asc']);
        }

        let keysNotInSort: string[] = [];
        let keysInSort: string[] = [];
        let inCat: ICategory = {};
        let productMap = new Map();
        // let notInCat: ICategory = {};
        const allowedCollections = ['ow', 'main', 'sport', 'swim', 'outerwear']
        if (allowedCollections.indexOf(collectionName.toLowerCase()) === -1) {
            collectionName = 'no-collection';
        }

        if (collectionName === 'no-collection') {
            // return categories

            for (const categoryName in categories) {
                productMap.set(categoryName, categories[categoryName]);
            }

            return productMap;
        }

        if (productListCategorySort[collectionName.toLowerCase()]) {
            keysNotInSort = Object.keys(categories)
                .filter(key => productListCategorySort[collectionName.toLowerCase()].indexOf(key) === -1 && key.toLowerCase() !== 'marketing')

            keysInSort = Object.keys(categories)
                .filter(key => productListCategorySort[collectionName.toLowerCase()].indexOf(key) !== -1 && key.toLowerCase() !== 'marketing')

            keysInSort = sortBy(keysInSort, (item) => {
                return productListCategorySort[collectionName.toLowerCase()].indexOf(item)
            });
        }

        //  orderBy(categories[i], ['masterId'],['asc']);
        for (const categoryName of keysInSort) {
            inCat[categoryName] = categories[categoryName];
            let newSort = this.sortBySeasonMaster(categories[categoryName])

            productMap.set(categoryName, newSort);
        }

        for (const categoryName of keysNotInSort) {
            let newSort = this.sortBySeasonMaster(categories[categoryName])
            productMap.set(categoryName, newSort);
        }
    
        if (categories['Marketing']) {
            let newSort = this.sortBySeasonMaster(categories['Marketing'])
            productMap.set('Marketing', newSort);
        }

        return productMap;
    }

    getProductCategories(styles: Style[]): ICategory {
        let categories: ICategory = {};
        let masterIds = uniq(styles.map(style => style.masterId.substring(1)));
        masterIds = uniq(masterIds.map(masterId => masterId.substring(0, masterId.length - 4)));
        masterIds = masterIds.filter(masterId => masterId.startsWith('W') || masterId.startsWith('S'))
        let years = uniq(masterIds.map(masterId => masterId.substring(1)));
        let sortKeys: string[] = [];

        for (const year of years.sort().reverse()) {
            sortKeys.push('W' + year)
            sortKeys.push('S' + year)
        }

        for (const style of styles) {
            if (!categories[style.productCategory]) {
                categories[style.productCategory] = [];
            }

            categories[style.productCategory].push(style);
        }

        // for (const key in categories) {
        //     const category = clone(categories[key]);

        //     const sorted = category.sort((cat1, cat2) => {
        //         let m1 = cat1.masterId.substring(1);
        //         m1 = m1.substring(0, m1.length - 4);
        //         let m2 = cat2.masterId.substring(1);
        //         m2 = m2.substring(0, m2.length - 4);
                
        //         const index1 = sortKeys.indexOf(m1);
        //         const index2 = sortKeys.indexOf(m2);
                
        //         if (index1 === -1 && index2 === -1) {
        //             return -1;
        //         }

        //         if (index1 === -1 && index2 !== -1) {
        //             return 1
        //         }

        //         if (index2 === -1 && index1 !== -1) {
        //             return -1
        //         }

        //         if (index1 > index2) {
        //             return 1;
        //         }

        //         if (index1 < index2) {
        //             return -1;
        //         }

        //         return -1;
        //     })
            
        //     categories[key] = sorted;
        // }

        for (const i in categories) {
            categories[i] = orderBy(categories[i], ['masterId'],['asc']);
        }

        return categories;
    }

    public static getDerivedStateFromProps(props: Props, state: State) {
        if (props.orderState.order && props.orderState.order !== state.order) {
          return {
              order: props.orderState.order,
          }
        }

        return null;
    }

    handleOnChangeProduct = async (item: MoloItem) => {
        const currencyCode = this.props.userState.user.currencyCode || 'EUR';
        const pricegroup   = this.props.userState.user ? this.props.userState.user.customerData.pricegroup : 'ALL';
        const response = await ProductApi.getMaster(item.masterId, item.colorCode, currencyCode,pricegroup);
        const product = response.data;
        
        this.handleOnProductClick(createStyle(product));
    }

    handleOnProductClick = (product: Style) => {
        // this.t = TweenLite.to(this.box, 1, {duration: 1, opacity: 1, y: 0, stagger: 0.25});
        // this.t = TweenLite.to(this.box, .2, {y: -200, opacity: 0})

        setTimeout(() => {
            const overlayAlreadyOpen = this.state.showModal;
            this.setState({
                selectedProduct: StyleBean.build(product, 'style'),
                showModal: true,
            }, () => {
                if (overlayAlreadyOpen) {
                    replaceProductOverlayHistory();
                } else {
                    pushProductOverlayHistory();
                    this.overlayHistoryPushed = true;
                }
            });
        }, 200)
        
    }

    hide = (fromPopstate = false) => {
        const hadPushed = this.overlayHistoryPushed;
        this.overlayHistoryPushed = false;

        this.setState({ showModal: false, productOverlayComponent: null, changes: {} }, () => {
            if (!fromPopstate && hadPushed) {
                closeProductOverlayHistory();
            }
        });
    }

    applyBasketChanges = (changes: basketLine) => {
        const newChanges = { ...this.state.changes, ...changes}
        this.setState({changes: newChanges})
    }

    applyChanges = (changes?: basketLine) => {
        if (this.props.orderState.order) {
            const payload = changes !== undefined ? changes : this.state.changes;
            if (!Object.keys(payload).length) {
                return;
            }
            this.props.applyChanges(this.props.orderState.order.orderheader.appOrderId, payload);
            this.setState({changes: {}}, () => {
                this.hide();
            })
        }
    }

    goBack = () => {
        if (this.props.history) {
            this.props.history.goBack();
        }        
    }

    isInBasket = (product: Style) => {
        return this.props.orderState.order && !!this.props.orderState.order.orderLines.find((line) => {
            return line.masterid === product.masterId && line.colorcode === product.colorCode;
        })
    }

    isOnWishlist = (product: Style) =>
        !!this.props.wishlist.itemKeys[wishlistItemKey(product.masterId, product.colorCode)];

    handleWishlistToggle = async (e: React.MouseEvent, product: Style) => {
        e.stopPropagation();
        const on = this.isOnWishlist(product);
        const originElement = e.currentTarget as HTMLElement;
        await this.props.toggleWishlistItem(product.masterId, product.colorCode, on);
        if (!on) {
            triggerWishlistFlyAnimation(originElement);
        }
    }

    onSticky = (categoryName: string) => {
        const stickies = this.state.stickies;
        stickies.push(categoryName);
        this.setState({ stickies });
    };

    onUnSticky = (categoryName: string) => {
        const stickies = this.state.stickies;
        const index = stickies.indexOf(categoryName);
        if (index > -1) {
            stickies.splice(index, 1);
        }

        this.setState({ stickies });
    };

    toggleFilter = () => {
        this.setState({ showFilter: !this.state.showFilter });
    };

    handleGridViewChange = (mode: ProductGridViewUiMode) => {
        writeProductGridView(mode);
        this.setState({ gridViewMode: mode });
    }

    renderProductListHeader = (title: string, extraToolbar?: React.ReactNode) => (
        <div className="product-list__header">
            <span className="product-list__header__text">{title}</span>
            <div className="product-list__header__actions">
                {extraToolbar}
                <div className="product-list__header__view desktop-only">
                    <ProductGridViewToggle
                        value={this.state.gridViewMode}
                        onChange={this.handleGridViewChange}
                    />
                </div>
            </div>
        </div>
    );

    renderCategory(styles: Style[], categoryName: string) {
        if (!styles.length) {
            return null
        }

        return (
            <React.Fragment key={categoryName}>
                <StickyHeader
                    title={ categoryName }
                    onSticky={this.onSticky}
                    onUnSticky={this.onUnSticky}
                />
                <ul className={plClassName(this.state.gridViewMode)}>
                    {
                        styles && styles.map((product:Style, index:number) =>
                            <li
                                key={index}
                                onClick={ () => this.handleOnProductClick(product) }
                                className={wrapperClassName(this.state.gridViewMode, index)}
                            >
                                <ProductListItem
                                    product={StyleBean.build(product, 'style')}
                                    discount={this.props.lineDiscount}
                                    inBasket={this.isInBasket(product)}
                                    lazyLoadMoloMaster={this.props.lazyLoadMoloMaster}
                                    quantityLabel={'Available'}
                                    hidePrice={this.props.hidePrice}
                                    wishlistOn={this.isOnWishlist(product)}
                                    wishlistLoading={
                                        this.props.wishlist.loading ||
                                        this.props.wishlist.mutatingKey ===
                                            wishlistItemKey(product.masterId, product.colorCode)
                                    }
                                    onWishlistClick={(e) => this.handleWishlistToggle(e, product)}
                                    imageProfile={
                                        isEditorialHalfItem(this.state.gridViewMode, index)
                                            ? 'large'
                                            : 'thumb'
                                    }
                                />
                            </li>
                        )
                    }
                </ul>
            </React.Fragment>
        )
    }

    renderOverlay() {

        if (!this.state.selectedProduct || !this.state.showModal) {
            return null;
        }
        console.log('open product');

        console.dir(this.state.selectedProduct);
        return (
            <ProductOverlay
                key={
                    this.state.selectedProduct.masterId +
                    '-' +
                    this.state.selectedProduct.colorCode
                }
                product={StyleBean.build(this.state.selectedProduct, 'style')}
                hide={this.hide}
                order={this.props.orderState.order}
                changes={this.state.changes}
                applyBasketChanges={this.applyBasketChanges}
                applyChanges={this.applyChanges}
                changeProduct={this.handleOnChangeProduct}
                showModal={this.state.showModal}
                deliveryWindows={this.props.productState.deliveryWindows}
                orderType={
                    this.props.useProductOrderType
                        ? this.state.selectedProduct.orderType
                        : this.props.orderType || this.props.match.params.orderType
                }
                checkOrderType={this.props.checkOrderType}
                useAllOrderTypesForMasterColor={this.props.useAllOrderTypesForMasterColor}
                validOrderTypes={
                    this.props.validOrderTypesByKey && this.state.selectedProduct
                        ? this.props.validOrderTypesByKey[
                              wishlistItemKey(
                                  this.state.selectedProduct.masterId,
                                  this.state.selectedProduct.colorCode
                              )
                          ]
                        : undefined
                }
            />
        )
    }

    updateItems = () => {
        this.setState({
            hasMore: true,
            elements: [],
            currentCategory: this.state.currentCategory,
            infiniteLoaderCurrentIndex: 0
        }, () => {
            this.loadItems()
        })
    }

    loadItems = () => {

        if (this.state.currentCategory !== '') {
            let elements: IElements[] = []

            // let productSortedByCategory = this.getProductCategories(this.state.filteredStyles);
            let currentCategory = this.state.currentCategory;
            let infiniteLoaderCurrentIndex = this.state.infiniteLoaderCurrentIndex;
            let counter = 0;
            let hasMore = true;
            console.log('loadItems infinity list');            

            while (counter < 100) {
                if (!this.state.productSortedByCategoryAsMap.has(currentCategory)) {
                    counter = 100;
                    hasMore = false;
                    break;
                }

                const styles = this.state.productSortedByCategoryAsMap.get(currentCategory);
                const nextElement = styles && styles[infiniteLoaderCurrentIndex] ? styles[infiniteLoaderCurrentIndex] : undefined

                if (nextElement) {

                    if (infiniteLoaderCurrentIndex === 0) {
                        const header: IHeader = {description: currentCategory}
                        elements.push(
                            {
                                type: 'iheader',
                                header: header,
                            }
                        )
                    }

                    const product = nextElement;
                    elements.push(
                        {
                            type: "style",
                            style: product
                        }
                    )
                    counter++
                    infiniteLoaderCurrentIndex++;
                } else {
                    infiniteLoaderCurrentIndex = 0;
                    const keys = [ ...this.state.productSortedByCategoryAsMap.keys() ] 
                    currentCategory = keys[(keys.indexOf(currentCategory) + 1)]; 
                }
            }
            

            this.setState({
                hasMore,
                elements: [...this.state.elements, ...elements],
                currentCategory,
                infiniteLoaderCurrentIndex
            }, () => {
                this.restoreScrollIfNeeded();
                this.reapplyScrollIfNeeded();
            })
        }
    }

    // loadItems = () => {
    //     if (this.state.currentCategory !== '') {
    //         let elements: IElements[] = []

            

    //         // let productSortedByCategory = this.getProductCategories(this.state.filteredStyles);
    //         let currentCategory = this.state.currentCategory;
    //         let infiniteLoaderCurrentIndex = this.state.infiniteLoaderCurrentIndex;
    //         let counter = 0;
    //         let hasMore = true;
            

    //         while (counter < 100) {
    //             if (!this.state.productSortedByCategory[currentCategory]) {
    //                 counter = 100;
    //                 hasMore = false;
    //                 break;
    //             }

    //             if (this.state.productSortedByCategory[currentCategory][infiniteLoaderCurrentIndex]) {

    //                 if (infiniteLoaderCurrentIndex === 0) {
    //                     const header: IHeader = {description: currentCategory}
    //                     elements.push(
    //                         {
    //                             type: 'iheader',
    //                             header: header,
    //                         }
    //                     )
    //                 }

    //                 const product = this.state.productSortedByCategory[currentCategory][infiniteLoaderCurrentIndex];
    //                 elements.push(
    //                     {
    //                         type: "style",
    //                         style: product
    //                     }
    //                 )
    //                 counter++
    //                 infiniteLoaderCurrentIndex++;
    //             } else {
    //                 infiniteLoaderCurrentIndex = 0;
    //                 const keys = Object.keys(this.state.productSortedByCategory).sort().reverse();
    //                 currentCategory = keys[(keys.indexOf(currentCategory) + 1)]; 
    //             }
    //         }

    //         console.log(elements, 'elements :: on first load')
            

    //         this.setState({
    //             hasMore,
    //             elements: [...this.state.elements, ...elements],
    //             currentCategory,
    //             infiniteLoaderCurrentIndex
    //         })
    //     }
    // }

    render() {
        const collection = this.matchCollection();

        if (this.props.simple) {
            const floatCat = this.props.simpleFloatingCategoryTitle;
            const productListBody = this.renderSimpleProductListBody();

            if (floatCat !== undefined && floatCat !== null && floatCat !== '') {
                /* One title bar only; no StickyHeader (that duplicated the category line). */
                const headerBarText = floatCat;

                return (
                    <div
                        className={
                            'product-list product-list--wishlist-floating' +
                            (this.state.showModal ? ' product-list--overlay-open' : '')
                        }
                        ref={(e) => (this.box = e)}
                    >
                        {this.state.showModal && this.renderOverlay()}
                        {this.renderProductListHeader(
                            headerBarText,
                            this.props.renderExtraToolbarRow
                        )}
                        <div className="product-list__content">
                            <div className="product-list__list" id="sticky-container">
                                {productListBody}
                            </div>
                        </div>
                    </div>
                );
            }

            return (
                <div className={'product-list--simple'}>
                    {this.state.showModal && this.renderOverlay()}
                    <div className="product-list__content">
                        <div className="product-list__list">
                            <div className="product-list__list" id="sticky-container">
                                {productListBody}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const isReorder =
            this.props.match &&
            this.props.match.params &&
            this.props.match.params.orderType === 'REORDER';

        return (
            <div className={"product-list" + (this.state.showFilter ? " filter-is-active" : "") + (this.state.isScrollRestoring ? " product-list--scroll-restoring" : "")} ref={e => this.box = e}>
                {this.renderProductListHeader(this.state.stickies[this.state.stickies.length - 1])}

                <div className="product-list__content">
                    {
                        !this.props.ignoreFilter &&
                        !this.props.hideFilterChrome &&
                        <FilterComponent
                            styles={this.getQuickFilteredProducts()}
                            facetRevision={this.state.facetRevision}
                            collectionName={ collection }
                            showFilter={ this.state.showFilter } />
                    }
                    {
                        !this.props.useInfiniteScroll &&
                        <div className="product-list__list" id="sticky-container">
                            {
                                Object.keys(this.state.productSortedByCategory).sort().reverse().map((key, index) => {
                                    return (
                                        this.renderCategory(this.state.productSortedByCategory[key], key)
                                    )
                                })
                            }
                        </div>
                    }
                    {
                        this.props.useInfiniteScroll &&
                        <InfinityList 
                            elements={this.state.elements}
                            onSticky={this.onSticky}
                            onUnSticky={this.onUnSticky}
                            handleOnProductClick={this.handleOnProductClick}
                            lineDiscount={this.props.lineDiscount}
                            isInBasket={this.isInBasket}
                            lazyLoadMoloMaster={this.props.lazyLoadMoloMaster}
                            loadItems={this.loadItems}
                            hasMore={this.state.hasMore}
                            isOnWishlist={this.isOnWishlist}
                            wishlistFetching={this.props.wishlist.loading}
                            wishlistMutatingKey={this.props.wishlist.mutatingKey}
                            onWishlistToggle={this.handleWishlistToggle}
                            gridViewMode={this.state.gridViewMode}
                        />
                    }
                </div>

                {((!this.props.ignoreFilter && !this.props.hideFilterChrome) ||
                    this.props.renderExtraToolbarRow) && (
                <div className="filter-dropdown__toggler__row">
                    {!this.props.ignoreFilter && !this.props.hideFilterChrome && (
                    <>
                    <div className="filter-dropdown__toggler__wrapper">
                        <div
                            className={"filter-dropdown__toggler" + (this.state.showFilter ? " open" : "")}
                            onClick={this.toggleFilter}
                        >
                            <span className="filter-dropdown__toggler__title desktop-only">
                            {!this.state.showFilter ? 'Show filter' : 'Hide filter'}
                        </span>
                            <FilterIcon />
                        </div>
                    </div>
                    {isReorder &&
                    <div className="filter-dropdown__toggler__wrapper filter-dropdown__toggler__wrapper--in-season">
                        <button
                            type="button"
                            className={"filter-chip-toggle" + (this.state.showInSeasonOnly ? " is-active" : "")}
                            aria-pressed={this.state.showInSeasonOnly}
                            onClick={() => { this.setState({ showInSeasonOnly: !this.state.showInSeasonOnly }) }}
                        >
                            {this.state.showInSeasonOnly && <span className="filter-chip-toggle__check">✓</span>}
                            <span>In season only</span>
                        </button>
                    </div>}
                    {this.props.showAgeSegmentQuickFilter &&
                    <div className="filter-dropdown__toggler__wrapper filter-dropdown__toggler__wrapper--age-segment">
                        <select
                            id="age-segment-quick-filter"
                            aria-label="Age segment"
                            className={
                                'filter-chip-select' +
                                (this.state.ageSegmentQuickFilter !== 'all' ? ' is-active' : '')
                            }
                            value={this.state.ageSegmentQuickFilter}
                            onChange={(e) => {
                                const v = e.target.value as AgeSegmentQuickFilter;
                                this.setState({ ageSegmentQuickFilter: v });
                            }}
                        >
                            <option value="all">All</option>
                            <option value="baby">Baby</option>
                            <option value="junior">Junior</option>
                            <option value="youth">Youth</option>
                        </select>
                    </div>}
                    </>
                    )}
                    {this.props.renderExtraToolbarRow}
                </div>
                )}
                {this.state.showModal && this.renderOverlay()}
            </div>
        )
    }
}

const mapStateToProps = (states: RootState, ownProps: OwnProps): StateProps => {
    return {
      orderState: states.order.order,
      filterState: states.session.filter,
      productState: states.productStore.productStore,
      userState: states.user.user,
      wishlist: states.wishlist,
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>, ownProps: OwnProps): DispatchProps => {
    return {
        getOrder: async (orderId: number) => {
            await dispatch(getOrder(orderId))
            // console.log('getOrder completed [UI]')
        },
        applyChanges: async (orderId: number, changes: basketLine) => {
            await dispatch(applyChanges(orderId, changes))
            // console.log('applyChanges completed [UI]')
        },
        toggleWishlistItem: async (masterId: string, colorCode: string, isCurrentlyOnList: boolean) => {
            await dispatch(toggleWishlistItem(masterId, colorCode, isCurrentlyOnList))
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductList))
